export interface VideoItem {
  id: string;
  title: string;
  category: 'movie' | 'drama' | 'variety' | 'mv';
  categoryLabel: string;
  thumbnail: string;
  rating: number;
  year: number;
  region: string;
  duration: string;
  description: string;
  tags: string[];
  views: number;
  updateDate: string;
  isHot: boolean;
  isNew: boolean;
}

export const categories = [
  { slug: 'movie', label: '日韩电影', icon: 'ri-film-line', desc: '最新日韩电影大片，高清在线观看' },
  { slug: 'drama', label: '日韩电视剧', icon: 'ri-tv-line', desc: '热门日韩电视剧全集，持续更新' },
  { slug: 'variety', label: '日韩综艺', icon: 'ri-emotion-laugh-line', desc: '爆笑日韩综艺节目，欢乐不停' },
  { slug: 'mv', label: '日韩MV', icon: 'ri-music-line', desc: '日韩流行音乐MV，视听盛宴' },
];

export const videos: VideoItem[] = [
  {
    id: 'movie-1',
    title: '情书',
    category: 'movie',
    categoryLabel: '日韩电影',
    thumbnail: 'https://readdy.ai/api/search-image?query=Japanese%20romantic%20movie%20aesthetic%20scene%20with%20snow%20covered%20mountain%20landscape%2C%20nostalgic%20warm%20tone%2C%20cinematic%20lighting%2C%20soft%20focus%2C%20vintage%20film%20atmosphere%2C%20emotional%20storytelling%20vibe%2C%20clean%20minimal%20composition&width=800&height=450&seq=movie-1&orientation=landscape',
    rating: 9.2,
    year: 1995,
    region: '日本',
    duration: '117分钟',
    description: '日本纯爱电影经典之作，讲述了渡边博子在未婚夫藤井树去世后，寄出了一封通往天国的情书，却意外收到回信的故事。影片以其唯美的画面和细腻的情感打动了无数观众。',
    tags: ['爱情', '经典', '纯爱', '岩井俊二'],
    views: 1280000,
    updateDate: '2026-08-08',
    isHot: true,
    isNew: false,
  },
  {
    id: 'movie-2',
    title: '寄生虫',
    category: 'movie',
    categoryLabel: '日韩电影',
    thumbnail: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20movie%20aesthetic%20with%20modern%20house%20architecture%20contrast%2C%20dramatic%20lighting%2C%20dark%20toned%20cinematic%20scene%2C%20suspenseful%20atmosphere%2C%20rainy%20night%20mood%2C%20Korean%20film%20poster%20style&width=800&height=450&seq=movie-2&orientation=landscape',
    rating: 9.3,
    year: 2019,
    region: '韩国',
    duration: '132分钟',
    description: '奉俊昊执导的奥斯卡最佳影片，讲述了一家四口全是无业游民，通过精心策划混入富豪家庭工作的故事。影片深刻揭示了韩国社会的阶级分化问题。',
    tags: ['剧情', '悬疑', '社会', '奥斯卡'],
    views: 3560000,
    updateDate: '2026-08-09',
    isHot: true,
    isNew: false,
  },
  {
    id: 'movie-3',
    title: '你的名字',
    category: 'movie',
    categoryLabel: '日韩电影',
    thumbnail: 'https://readdy.ai/api/search-image?query=Japanese%20animated%20film%20aesthetic%20with%20starry%20night%20sky%20and%20comet%2C%20beautiful%20scenery%2C%20dreamy%20atmosphere%2C%20anime%20style%20landscape%2C%20twilight%20colors%2C%20emotional%20and%20romantic%20scene&width=800&height=450&seq=movie-3&orientation=landscape',
    rating: 9.0,
    year: 2016,
    region: '日本',
    duration: '106分钟',
    description: '新海诚执导的动画电影，讲述了住在乡下的女高中生三叶与住在东京的男高中生�的�的灵魂互换的奇幻爱情故事，画面极其精美。',
    tags: ['动画', '爱情', '奇幻', '新海诚'],
    views: 2890000,
    updateDate: '2026-08-07',
    isHot: true,
    isNew: false,
  },
  {
    id: 'movie-4',
    title: '老男孩',
    category: 'movie',
    categoryLabel: '日韩电影',
    thumbnail: 'https://readdy.ai/api/search-image?query=Korean%20revenge%20thriller%20movie%20aesthetic%20with%20dark%20alley%20scene%2C%20neo%20noir%20lighting%2C%20intense%20atmosphere%2C%20gritty%20urban%20street%2C%20dramatic%20shadow%20play%2C%20bold%20red%20color%20accents&width=800&height=450&seq=movie-4&orientation=landscape',
    rating: 8.8,
    year: 2003,
    region: '韩国',
    duration: '120分钟',
    description: '朴赞郁执导的复仇三部曲之一，讲述了一个男人被无故囚禁15年后重获自由，展开复仇的故事。影片以其震撼的剧情和独特的视觉风格著称。',
    tags: ['悬疑', '复仇', '动作', '朴赞郁'],
    views: 1560000,
    updateDate: '2026-08-06',
    isHot: false,
    isNew: false,
  },
  {
    id: 'movie-5',
    title: '千与千寻',
    category: 'movie',
    categoryLabel: '日韩电影',
    thumbnail: 'https://readdy.ai/api/search-image?query=Japanese%20animated%20fantasy%20film%20aesthetic%20with%20traditional%20bathhouse%20building%2C%20magical%20atmosphere%2C%20spirited%20away%20inspired%2C%20vibrant%20colors%2C%20whimsical%20architecture%2C%20dreamy%20Japanese%20fantasy%20world&width=800&height=450&seq=movie-5&orientation=landscape',
    rating: 9.4,
    year: 2001,
    region: '日本',
    duration: '125分钟',
    description: '宫崎骏的经典动画电影，讲述了一个小女孩误入神灵世界后的奇幻冒险。影片荣获奥斯卡最佳动画长片奖，是日本电影史上票房最高的作品。',
    tags: ['动画', '奇幻', '冒险', '宫崎骏'],
    views: 4200000,
    updateDate: '2026-08-09',
    isHot: true,
    isNew: false,
  },
  {
    id: 'drama-1',
    title: '非自然死亡',
    category: 'drama',
    categoryLabel: '日韩电视剧',
    thumbnail: 'https://readdy.ai/api/search-image?query=Japanese%20medical%20forensic%20drama%20aesthetic%20with%20laboratory%20setting%2C%20clean%20modern%20interior%2C%20professional%20atmosphere%2C%20cool%20white%20lighting%2C%20scientific%20vibe%2C%20Japanese%20TV%20drama%20style&width=800&height=450&seq=drama-1&orientation=landscape',
    rating: 9.1,
    year: 2018,
    region: '日本',
    duration: '10集/每集45分钟',
    description: '石原里美主演的法医题材日剧，讲述了非自然死亡原因研究所（UDI Lab）的法医们通过解剖遗体查明真正死因的故事，剧情紧凑感人。',
    tags: ['法医', '悬疑', '职场', '石原里美'],
    views: 2100000,
    updateDate: '2026-08-08',
    isHot: true,
    isNew: false,
  },
  {
    id: 'drama-2',
    title: '黑暗荣耀',
    category: 'drama',
    categoryLabel: '日韩电视剧',
    thumbnail: 'https://readdy.ai/api/search-image?query=Korean%20revenge%20drama%20aesthetic%20with%20elegant%20woman%20in%20dark%20setting%2C%20sophisticated%20interior%2C%20moody%20lighting%2C%20cold%20color%20palette%2C%20dramatic%20tension%2C%20Korean%20drama%20cinematic%20style&width=800&height=450&seq=drama-2&orientation=landscape',
    rating: 9.0,
    year: 2022,
    region: '韩国',
    duration: '16集/每集50分钟',
    description: '宋慧乔主演的复仇题材韩剧，讲述了一个曾在高中时遭受校园暴力的女人，精心策划多年后向加害者和旁观者展开复仇的故事，剧情扣人心弦。',
    tags: ['复仇', '校园', '悬疑', '宋慧乔'],
    views: 5800000,
    updateDate: '2026-08-09',
    isHot: true,
    isNew: true,
  },
  {
    id: 'drama-3',
    title: '半泽直树',
    category: 'drama',
    categoryLabel: '日韩电视剧',
    thumbnail: 'https://readdy.ai/api/search-image?query=Japanese%20business%20drama%20aesthetic%20with%20corporate%20office%20banking%20setting%2C%20intense%20meeting%20room%20atmosphere%2C%20professional%20suits%2C%20dramatic%20lighting%2C%20Japanese%20TV%20series%20style&width=800&height=450&seq=drama-3&orientation=landscape',
    rating: 9.1,
    year: 2013,
    region: '日本',
    duration: '10集/每集54分钟',
    description: '堺雅人主演的银行职场剧，讲述了东京中央银行职员半泽直树在职场中与各种势力斗智斗勇的故事，"加倍奉还"成为经典台词。',
    tags: ['职场', '金融', '复仇', '堺雅人'],
    views: 1850000,
    updateDate: '2026-08-07',
    isHot: false,
    isNew: false,
  },
  {
    id: 'drama-4',
    title: '孤单又灿烂的神-鬼怪',
    category: 'drama',
    categoryLabel: '日韩电视剧',
    thumbnail: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20romance%20drama%20aesthetic%20with%20autumn%20scenery%2C%20golden%20leaves%2C%20romantic%20atmosphere%2C%20soft%20warm%20lighting%2C%20beautiful%20Korean%20landscape%2C%20fantasy%20romance%20vibe&width=800&height=450&seq=drama-4&orientation=landscape',
    rating: 9.2,
    year: 2016,
    region: '韩国',
    duration: '16集/每集70分钟',
    description: '孔刘、金高银主演的奇幻爱情剧，讲述了长生不死的鬼怪为了结束永恒的生命而需要人类新娘的故事，画面唯美，配乐动人。',
    tags: ['奇幻', '爱情', '浪漫', '孔刘'],
    views: 4500000,
    updateDate: '2026-08-09',
    isHot: true,
    isNew: false,
  },
  {
    id: 'variety-1',
    title: 'Running Man',
    category: 'variety',
    categoryLabel: '日韩综艺',
    thumbnail: 'https://readdy.ai/api/search-image?query=Korean%20variety%20show%20running%20game%20aesthetic%20with%20outdoor%20playground%20setting%2C%20colorful%20fun%20atmosphere%2C%20group%20of%20people%20playing%20games%2C%20bright%20sunny%20day%2C%20energetic%20vibe&width=800&height=450&seq=variety-1&orientation=landscape',
    rating: 9.3,
    year: 2010,
    region: '韩国',
    duration: '持续更新中',
    description: '韩国SBS电视台的招牌综艺节目，由刘在石、金钟国等固定成员组成，每期进行各种任务和游戏，是全球最受欢迎的韩国综艺节目之一。',
    tags: ['户外', '游戏', '搞笑', '刘在石'],
    views: 8900000,
    updateDate: '2026-08-10',
    isHot: true,
    isNew: true,
  },
  {
    id: 'variety-2',
    title: '月曜夜未央',
    category: 'variety',
    categoryLabel: '日韩综艺',
    thumbnail: 'https://readdy.ai/api/search-image?query=Japanese%20variety%20talk%20show%20aesthetic%20with%20studio%20setting%2C%20colorful%20set%20design%2C%20fun%20atmosphere%2C%20bright%20lighting%2C%20entertaining%20Japanese%20TV%20show%20style%2C%20comedic%20vibe&width=800&height=450&seq=variety-2&orientation=landscape',
    rating: 9.0,
    year: 2012,
    region: '日本',
    duration: '持续更新中',
    description: '日本电视台的深夜综艺节目，由村上信五和松子Deluxe主持，以街头采访和各种奇妙话题著称，被誉为日本最好笑的综艺节目之一。',
    tags: ['谈话', '街头', '搞笑', '松子'],
    views: 3200000,
    updateDate: '2026-08-09',
    isHot: true,
    isNew: false,
  },
  {
    id: 'variety-3',
    title: '新西游记',
    category: 'variety',
    categoryLabel: '日韩综艺',
    thumbnail: 'https://readdy.ai/api/search-image?query=Korean%20travel%20variety%20show%20aesthetic%20with%20exotic%20location%2C%20group%20travel%20adventure%2C%20colorful%20costumes%2C%20fun%20group%20photo%20style%2C%20bright%20vibrant%20colors%2C%20travel%20entertainment%20vibe&width=800&height=450&seq=variety-3&orientation=landscape',
    rating: 9.4,
    year: 2015,
    region: '韩国',
    duration: '持续更新中',
    description: '罗英锡PD打造的旅行综艺，姜虎东、李寿根、殷志源等成员前往世界各地，在旅途中完成各种游戏任务，笑料不断。',
    tags: ['旅行', '游戏', '搞笑', '罗英锡'],
    views: 4100000,
    updateDate: '2026-08-08',
    isHot: true,
    isNew: false,
  },
  {
    id: 'mv-1',
    title: 'Dynamite - BTS',
    category: 'mv',
    categoryLabel: '日韩MV',
    thumbnail: 'https://readdy.ai/api/search-image?query=Kpop%20music%20video%20aesthetic%20with%20retro%20disco%20theme%2C%20colorful%20pastel%20background%2C%20energetic%20dance%20scene%2C%20vibrant%201970s%20inspired%20fashion%2C%20bright%20and%20fun%20atmosphere&width=800&height=450&seq=mv-1&orientation=landscape',
    rating: 9.5,
    year: 2020,
    region: '韩国',
    duration: '3:43',
    description: '防弹少年团（BTS）首支全英文单曲《Dynamite》的MV，以复古迪斯科风格呈现，充满活力的舞蹈和欢快的旋律，创下多项YouTube纪录。',
    tags: ['K-POP', 'BTS', '舞曲', '迪斯科'],
    views: 18500000,
    updateDate: '2026-08-10',
    isHot: true,
    isNew: false,
  },
  {
    id: 'mv-2',
    title: 'Lemon - 米津玄师',
    category: 'mv',
    categoryLabel: '日韩MV',
    thumbnail: 'https://readdy.ai/api/search-image?query=Japanese%20music%20video%20aesthetic%20with%20yellow%20lemon%20theme%2C%20artistic%20visual%20style%2C%20minimal%20composition%2C%20warm%20golden%20lighting%2C%20emotional%20Japanese%20pop%20song%20atmosphere&width=800&height=450&seq=mv-2&orientation=landscape',
    rating: 9.6,
    year: 2018,
    region: '日本',
    duration: '4:16',
    description: '米津玄师为日剧《非自然死亡》创作的主题曲MV，以柠檬黄为主色调的极简视觉风格，配合深情的旋律和歌词，感动了无数听众。',
    tags: ['J-POP', '米津玄师', '抒情', '日剧主题曲'],
    views: 9500000,
    updateDate: '2026-08-09',
    isHot: true,
    isNew: false,
  },
  {
    id: 'mv-3',
    title: 'DDU-DU DDU-DU - BLACKPINK',
    category: 'mv',
    categoryLabel: '日韩MV',
    thumbnail: 'https://readdy.ai/api/search-image?query=Kpop%20girl%20group%20music%20video%20aesthetic%20with%20luxurious%20jewelry%20theme%2C%20pink%20and%20black%20color%20scheme%2C%20fashionable%20outfits%2C%20powerful%20dance%20performance%2C%20glamorous%20lighting&width=800&height=450&seq=mv-3&orientation=landscape',
    rating: 9.3,
    year: 2018,
    region: '韩国',
    duration: '3:30',
    description: 'BLACKPINK的代表作之一，MV以华丽的黑粉配色和酷炫的舞蹈编排著称，展现了四位成员的独特魅力，是K-POP历史上观看量最高的女团MV。',
    tags: ['K-POP', 'BLACKPINK', '嘻哈', '女团'],
    views: 22000000,
    updateDate: '2026-08-10',
    isHot: true,
    isNew: false,
  },
  {
    id: 'drama-5',
    title: '弥留之国的爱丽丝',
    category: 'drama',
    categoryLabel: '日韩电视剧',
    thumbnail: 'https://readdy.ai/api/search-image?query=Japanese%20survival%20thriller%20drama%20aesthetic%20with%20deserted%20city%20street%2C%20dystopian%20atmosphere%2C%20neon%20light%20reflections%2C%20empty%20Tokyo%20shibuya%20crossing%2C%20mysterious%20and%20tense%20mood&width=800&height=450&seq=drama-5&orientation=landscape',
    rating: 8.7,
    year: 2020,
    region: '日本',
    duration: '8集/每集50分钟',
    description: '山崎贤人、土屋太凤主演的Netflix日剧，改编自麻生羽吕的同名漫画，讲述了一群人在荒废的东京被迫参加致命游戏以求生存的故事。',
    tags: ['生存', '漫画改编', '悬疑', '科幻'],
    views: 3400000,
    updateDate: '2026-08-08',
    isHot: false,
    isNew: true,
  },
  {
    id: 'variety-4',
    title: '认识的哥哥',
    category: 'variety',
    categoryLabel: '日韩综艺',
    thumbnail: 'https://readdy.ai/api/search-image?query=Korean%20school%20themed%20variety%20show%20aesthetic%20with%20classroom%20setting%2C%20fun%20school%20uniforms%2C%20bright%20colorful%20set%2C%20comedic%20group%20interaction%2C%20entertaining%20classroom%20atmosphere&width=800&height=450&seq=variety-4&orientation=landscape',
    rating: 9.0,
    year: 2015,
    region: '韩国',
    duration: '持续更新中',
    description: 'JTBC电视台的招牌综艺，以高中教室为背景，由姜虎东、李寿根等人担任固定成员，每期邀请嘉宾进行各种有趣的环节和游戏。',
    tags: ['教室', '访谈', '搞笑', '姜虎东'],
    views: 2800000,
    updateDate: '2026-08-09',
    isHot: false,
    isNew: true,
  },
  {
    id: 'mv-4',
    title: '夜に駆ける - YOASOBI',
    category: 'mv',
    categoryLabel: '日韩MV',
    thumbnail: 'https://readdy.ai/api/search-image?query=Japanese%20music%20video%20animation%20style%20aesthetic%20with%20night%20cityscape%2C%20anime%20inspired%20visuals%2C%20running%20through%20the%20night%20theme%2C%20beautiful%20starry%20sky%2C%20emotional%20Japanese%20pop%20song%20vibe&width=800&height=450&seq=mv-4&orientation=landscape',
    rating: 9.4,
    year: 2019,
    region: '日本',
    duration: '4:22',
    description: 'YOASOBI的出道曲MV，以动画风格的视觉呈现，讲述了一个关于追逐与告别的故事。歌曲在流媒体平台创下多项纪录，是令和时代最具代表性的J-POP歌曲之一。',
    tags: ['J-POP', 'YOASOBI', '动画MV', '小说音乐化'],
    views: 12000000,
    updateDate: '2026-08-10',
    isHot: true,
    isNew: false,
  },
];

export const aboutContent = {
  brandIntro: {
    title: '品牌介绍',
    paragraphs: [
      '日韩视频精选合集成立于2024年，是专注于日本和韩国影视娱乐内容的综合性视频平台。我们致力于为华语地区的日韩文化爱好者提供最全面、最高清的日韩视频资源，涵盖日韩电影、日韩电视剧、日韩综艺节目和日韩音乐MV等多种类型。',
      '我们的内容团队每日精心筛选和更新优质的日韩视频内容，确保用户能够第一时间观看到最新的日韩电影大片、热门日韩电视剧、精彩日韩综艺和流行日韩MV。我们与多家日本和韩国的内容制作方建立了合作关系，为用户带来正版授权的日韩视频资源。',
      '日韩视频精选合集采用先进的视频播放技术，支持高清1080P甚至4K超高清画质，让用户在舒适的观看体验中享受日韩影视文化的魅力。无论您是日韩电影的忠实影迷、日韩电视剧的追剧达人、日韩综艺的欢乐观众，还是日韩流行音乐的爱好者，这里都能满足您的需求。',
    ],
  },
  reputation: {
    title: '用户口碑',
    testimonials: [
      {
        name: '张先生',
        avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Asian%20man%20in%20modern%20office%2C%20clean%20white%20background%2C%20friendly%20smile%2C%20professional%20attire%2C%20headshot%20photography&width=100&height=100&seq=avatar-1&orientation=squarish',
        comment: '日韩视频精选合集真的是日韩剧迷的福音！更新速度超快，画质也很清晰，每天晚上都会来这里追最新的日韩电视剧，强烈推荐给所有日韩文化爱好者。',
        rating: 5,
      },
      {
        name: '李小姐',
        avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Asian%20woman%20with%20warm%20smile%2C%20clean%20white%20background%2C%20natural%20lighting%2C%20modern%20professional%20look%2C%20headshot%20photography&width=100&height=100&seq=avatar-2&orientation=squarish',
        comment: '作为一个K-POP粉丝，这里简直是我的天堂！BLACKPINK、BTS的最新MV第一时间就能看到，画质和音质都特别好，每天都要来打卡。',
        rating: 5,
      },
      {
        name: '王先生',
        avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Asian%20man%20with%20glasses%2C%20clean%20white%20background%2C%20calm%20expression%2C%20business%20casual%20style%2C%20headshot%20photography&width=100&height=100&seq=avatar-3&orientation=squarish',
        comment: '日韩综艺资源非常全，Running Man、新西游记每期都有，而且更新特别及时。网站的分类也很清晰，找想要的内容非常方便，体验非常好。',
        rating: 5,
      },
    ],
    stats: [
      { value: '500万+', label: '日韩视频资源' },
      { value: '98%', label: '用户满意度' },
      { value: '200万+', label: '日韩视频爱好者' },
      { value: '365天', label: '日韩视频每日更新' },
    ],
  },
  contact: {
    title: '联系我们',
    address: '上海市浦东新区张江高科技园区',
    email: 'contact@jp-kr-video.com',
    phone: '400-888-0000',
    wechat: 'JPKR_Video',
    hours: '周一至周日 9:00 - 21:00',
  },
};

export const siteConfig = {
  name: '日韩视频精选合集',
  slogan: '探索最全日韩视频资源',
  description: '日韩视频精选合集，涵盖日韩电影、电视剧、综艺、音乐MV等高清内容。每日更新日韩视频，为日韩文化爱好者提供一站式观看体验。',
};